import React from 'react'

const ProjectListHeader = (props) => {
    let className = "project-list-header", descriptionClassName = "project-list-description"
    if (props.dark) {
        className += " dark";
        descriptionClassName += " dark";
    }
    return (
        <React.Fragment>
            <span className={className} {...props}>{props.title}</span>
            {props.description &&
                <span className={descriptionClassName}>{props.description}</span>
            }
        </React.Fragment>
    )
}

export default ProjectListHeader


// WEBPACK FOOTER //
// ./src/components/ProjectListHeader.js